<template>
  <v-expand-transition>
    <v-sheet
      :color="color + 33"
      class="alerts-chip"
      :class="{ block: this.block }"
    >
      <v-row no-gutters align="center">
        <v-col cols="auto" class="alerts-icon-col">
          <google-icon :icon="icon" :fill="fill" :color="color" />
        </v-col>
        <v-col class="alerts-text">
          {{ message }}
        </v-col>
      </v-row>
    </v-sheet>
  </v-expand-transition>
</template>
<script>
export default {
  name: "AlertsChips.vue",
  props: {
    message: { type: String, required: true },
    icon: { type: String, default: "warning" },
    color: { type: String, default: "#F2B166" },
    fill: { type: Boolean, default: false },
    block: { type: Boolean, default: false }
  }
};
</script>
<style src="@/styles/global.css"></style>
<style scoped>
.block {
  width: 100%;
}
</style>
